import _get from 'lodash/get';

import { findAllValues } from 'utils/DICTIONARY';

export default function formatShippingMethodType(method) {
  const methodsMap = findAllValues('retailerShippingMethodChoices') || {};
  return _get(methodsMap, method, '');
}
